/// CATALOG PRODUCT TYPE
export const CATALOG_SET_ALL_PRODUCT = "CATALOG_SET_ALL_PRODUCT"
export const CATALOG_SET_FILTERED_PRODUCTS = "CATALOG_SET_FILTERED_PRODUCT"
export const CATALOG_SET_SEARCHED_PRODUCTS = "CATALOG_SET_SEARCHED_PRODUCTS"
export const CATALOG_SET_CATEGORY = "CATALOG_SET_CATEGORY"
export const CATALOG_SET_PRICE = "CATALOG_SET_PRICE"
export const CATALOG_SET_SEARCH_KEY = "CATALOG_SET_SEARCH_KEY"
export const CATALOG_START_LOADING = "CATALOG_START_LOADING"
export const CATALOG_STOP_LOADING = "CATALOG_STOP_LOADING"
export const CATALOG_SET_ERROR_MESSAGE = "CATALOG_SET_ERROR_MESSAGE"

//DETAIL PRODUCT
export const DETAIL_PRODUCT_SET_DETAIL_PRODUCT = "DETAIL_PRODUCT_SET_DETAIL_PRODUCT"
export const DETAIL_PRODUCT_START_LOADING = "DETAIL_PRODUCT_START_LOADING"
export const DETAIL_PRODUCT_STOP_LOADING = "DETAIL_PRODUCT_STOP_LOADING"
export const DETAIL_PRODUCT_SET_ERROR_MESSAGE = "DETAIL_PRODUCT_SET_ERROR_MESSAGE"

// LANDING PRODUCT
export const LANDING_PRODUCT_SET_PRODUCTS_1 = "LANDING_PRODUCT_SET_PRODUCTS_1"
export const LANDING_PRODUCT_SET_PRODUCTS_2 = "LANDING_PRODUCT_SET_PRODUCTS_2"
export const LANDING_PRODUCT_START_LOADING = "LANDING_PRODUCT_START_LOADING"
export const LANDING_PRODUCT_STOP_LOADING = "LANDING_PRODUCT_STOP_LOADING"
export const LANDING_PRODUCT_SET_ERROR_MESSAGE = "LANDING_PRODUCT_SET_ERROR_MESSAGE"